export default "__VITE_ASSET__CAG66DlY__"